import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { ArrowLeft, Loader2, CheckCircle2 } from 'lucide-react'
import toast from 'react-hot-toast'
import authService from '@/services/authService'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card } from '@/components/ui/card'
import { Alert, AlertDescription } from '@/components/ui/alert'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      await authService.forgotPassword(email)
      setSubmitted(true)
      toast.success('Instrucciones enviadas a tu correo')
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error al enviar instrucciones')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-8 pt-safe pb-safe">
      <div className="w-full max-w-md">
        <Card className="p-6 sm:p-8 shadow-md">
          <RouterLink
            to="/login"
            className="inline-flex items-center gap-1.5 text-body-sm text-subtle hover:text-primary transition-colors mb-4"
          >
            <ArrowLeft size={14} /> Volver al login
          </RouterLink>

          <h1 className="font-display text-h1 font-semibold text-foreground leading-tight">
            Recuperar contraseña
          </h1>
          <p className="text-body-sm text-subtle mt-1 mb-5">
            Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu
            contraseña.
          </p>

          {submitted ? (
            <Alert variant="success">
              <CheckCircle2 size={16} />
              <AlertDescription>
                Hemos enviado instrucciones a <strong>{email}</strong>. Revisa tu bandeja de
                entrada.
              </AlertDescription>
            </Alert>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="fp-email">Correo electrónico</Label>
                <Input
                  id="fp-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  autoComplete="email"
                  placeholder="tu@email.com"
                />
              </div>

              <Button type="submit" size="cta" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <Loader2 size={18} className="animate-spin" />
                    Enviando…
                  </>
                ) : (
                  'Enviar instrucciones'
                )}
              </Button>
            </form>
          )}
        </Card>
      </div>
    </div>
  )
}
